// extracted by mini-css-extract-plugin
export var logo = "_ko-2";
export var logoWrapper = "_ko-1";
export var strip = "_ko-0";